import { FileWithPreview } from './mealItemFormData';
import {
  formDataToLocalizedString,
  LocalizedString,
} from '../common/localizedString';
import { MealType } from '../mealType';
import { MealItemFormData } from './mealItemFormData';

export interface MealItemFormModel {
  id?: string;
  name: LocalizedString;
  description?: LocalizedString;
  price: number;
  picture?: FileWithPreview | null;
  kitchenId: string;
  mealType: MealType;
  isAvailable: boolean;
  taxRateId?: string | null;
}

export const toMealItemFormModel = (
  mealItem: MealItemFormData
): MealItemFormModel => ({
  id: mealItem.id,
  name: formDataToLocalizedString(mealItem.names),
  description: mealItem.descriptions
    ? formDataToLocalizedString(mealItem.descriptions)
    : undefined,
  price: mealItem.price,
  picture: mealItem.picture instanceof File ? mealItem.picture : undefined,
  kitchenId: mealItem.kitchenId,
  mealType: mealItem.mealType,
  isAvailable: mealItem.isAvailable,
  taxRateId: mealItem.taxRateId ?? null,
});
